import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './InteractiveMapSearch.css';
import React, { useEffect, useState } from 'react';
import { SearchInputBox } from './SearchComponents/SearchInputBox';
import SearchResults from './SearchComponents/SearchResults';
import { SitecoreContextReactContext } from '../../../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../../utils/tealium';
var DEBOUNCE_TIME = 700;
export var InteractiveMapSearch = function InteractiveMapSearch(_ref) {
  var toggleSearch = _ref.toggleSearch,
    fields = _ref.fields,
    handleAllowSearch = _ref.handleAllowSearch,
    analytics = _ref.analytics,
    params = _ref.params,
    allowSearch = _ref.allowSearch,
    defaultTypeValues = _ref.defaultTypeValues,
    handleResetFiltersFromSearch = _ref.handleResetFiltersFromSearch,
    activeListingItemId = _ref.activeListingItemId,
    handleDisableNestedFiltersFromSearch = _ref.handleDisableNestedFiltersFromSearch,
    filterPinsBySearch = _ref.filterPinsBySearch,
    getActivePopupOnMap = _ref.getActivePopupOnMap,
    activeTopPicks = _ref.activeTopPicks,
    toggleActiveTopPicks = _ref.toggleActiveTopPicks,
    hits = _ref.hits;
  var _fields$targetItem = fields.targetItem,
    hitsPerPage = _fields$targetItem.hitsPerPage,
    placeholder = _fields$targetItem.placeholder,
    lbResultsFor = _fields$targetItem.lbResultsFor,
    lbNoResults = _fields$targetItem.lbNoResults;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    debounceTimer = _React$useState2[0],
    setDebounceTimer = _React$useState2[1];
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  useEffect(function () {
    if (query) {
      handleAllowSearch(true);
      handleDisableNestedFiltersFromSearch();
    } else {
      handleAllowSearch(false);
      handleResetFiltersFromSearch();
    }
  }, [query]);
  var handleInputChange = function handleInputChange(event) {
    var query = event.target.value;
    setQuery(query);
    clearTimeout(debounceTimer);
    setDebounceTimer(window.setTimeout(function () {
      if (query) {
        filterPinsBySearch(query);
        tealiumClickFunc(tealiumMergeClickData(analytics['searchAnalytics'], params), query);
      }
    }, DEBOUNCE_TIME));
  };
  var clearSearch = function clearSearch() {
    setQuery('');
  };
  return /*#__PURE__*/React.createElement(StyledContainer, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement(SearchInputBox, {
    placeholder: placeholder.value,
    rtl: rtl,
    handleInputChange: handleInputChange,
    query: query,
    clearSearch: clearSearch
  }), /*#__PURE__*/React.createElement(SearchResults, {
    lbNoResults: lbNoResults,
    sitecoreContext: sitecoreContext,
    lbResultsFor: lbResultsFor,
    defaultTypeValues: defaultTypeValues,
    activeListingItemId: activeListingItemId,
    getActivePopupOnMap: getActivePopupOnMap,
    hits: hits,
    query: query,
    mainHitsPerPage: hitsPerPage.value,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: toggleActiveTopPicks,
    analytics: analytics,
    params: params
  }));
};
var StyledContainer = function StyledContainer(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " im-search"),
    "data-cy": "search-container"
  }, children);
};
var commonStyles = "c1jsh5qi";
var ltrStyles = "lfsukou";
var rtlStyles = "r1kjlz4g";
export default InteractiveMapSearch;